import styled from "styled-components";

export const Button = styled.button`
  width: 60px;
  height: 60px;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  box-shadow: ${({ theme }) => theme.boxShadow};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${({ theme }) => theme.radius}px;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${({ theme }) => theme.colors.primary[500]};
    }
  }
`;
